import { render, staticRenderFns } from "./BookingStatistics.vue?vue&type=template&id=dc4ca972"
import script from "./BookingStatistics.vue?vue&type=script&lang=ts"
export * from "./BookingStatistics.vue?vue&type=script&lang=ts"
import style0 from "./BookingStatistics.vue?vue&type=style&index=0&id=dc4ca972&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports